import request from '@/utils/request.js'

export function getThumb(params) {
  return request({
    url: '/home/thumb',
    method: 'get',
    params: params
  })
}

export function getMusic() {
    return request({
      url: '/home/music',
      method: 'get'
    })
}

export function getInfo() {
  return request({
    url: '/home/info',
    method: 'get'
  })
}
